export default () => {
    const sliders = document.querySelectorAll('.blockHeroSlider__slider');
    if(!sliders) return;

    sliders.forEach(slider => {
        const splideSlider = new window.splide(slider, {
            type: 'loop',
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 3000
        })

        splideSlider.on( 'overflow', function ( isOverflow ) {
            splideSlider.options = {
                pagination: isOverflow,
                drag: isOverflow,
            };
        });

        splideSlider.mount();
    });
}